// extracted by mini-css-extract-plugin
export default {"container":"FAQBanner_container__-yTGN","entity":"FAQBanner_entity__euVK4","inner":"FAQBanner_inner__iw9CO","question":"FAQBanner_question__XrPQp","answer":"FAQBanner_answer__pqU1g"};